// extracted by mini-css-extract-plugin
export default {"menuBlock":"vG-z","title":"wG-z","nav":"xG-z","flexCell":"yG-z","facetLink":"zG-z"};